import toNumber from 'lodash/toNumber';
import type IPayrollCostCenter from 'types/company/payroll/IPayrollCostCenter';
import type { IPayrollCostCenterRequest } from 'types/company/payroll/IPayrollCostCenter';

export const fromCostCenterPayrolltoToCostCenterRequest = (
  costCenter: IPayrollCostCenter,
): IPayrollCostCenterRequest => ({ ...costCenter, locationId: toNumber(costCenter.locationId) });
